/**
 * assets/customizer-static.js
 * Customization logic for static products (Photo Frames, Magnets, Cards, Bookmarks, etc.).
 */
class StaticCustomizer extends BaseCustomizer {
  constructor(config) {
    super(config);
    this.currentPhotoGroupKey = null;
  }

  bindGlobalMethods() {
    super.bindGlobalMethods();
    window.openChangePhotoModal = (gKey) => this.openChangePhotoModal(gKey);
    window.closePhotoModal = (e) => this.closePhotoModal(e);
    window.closePhotoModalBtn = () => this.closePhotoModalBtn();
    window.handlePhotoSwapPreview = (input) => this.handlePhotoSwapPreview(input);
    window.applyPhotoSwap = () => this.applyPhotoSwap();
    window.syncPhotoVariant = () => this.syncPhotoVariant();
  }

  openChangePhotoModal(gKey) {
    const modal = document.getElementById('photo-frame-modal');
    if (!modal) return;
    
    this.currentPhotoGroupKey = gKey;
    window.currentPhotoGroupKey = gKey;
    
    document.getElementById('new-photo-input').value = '';
    const userPhotoLayer = document.getElementById('user-photo-layer');
    userPhotoLayer.src = '';
    userPhotoLayer.style.display = 'none';
    document.getElementById('photo-layer-placeholder').style.display = 'flex';
    document.getElementById('apply-photo-btn').disabled = true;

    const firstItem = this.allCustomizations.find(item => item.key && (item.key === gKey || item.key.startsWith(gKey + '-')));
    if (firstItem) {
      document.getElementById('ai-frame-layer').src = firstItem.imageUrl;
    }
    
    modal.style.display = 'flex';
    this.lockScreen();
  }

  closePhotoModalBtn() {
    const modal = document.getElementById('photo-frame-modal');
    if (modal) modal.style.display = 'none';
    this.unlockScreen();
    this.currentPhotoGroupKey = null;
    window.currentPhotoGroupKey = null;
    if (window.scrollToSelectedCustomization) window.scrollToSelectedCustomization();
  }

  closePhotoModal(event) {
    if (event.target.id === "photo-frame-modal") {
      // Prevent accidental closing by clicking background.
    }
  }

  handlePhotoSwapPreview(input) {
    const userPhotoLayer = document.getElementById('user-photo-layer');
    const placeholder = document.getElementById('photo-layer-placeholder');
    const applyBtn = document.getElementById('apply-photo-btn');
    
    if (input && input.files && input.files[0]) {
      const file = input.files[0];
      try {
        const localUrl = URL.createObjectURL(file);
        userPhotoLayer.src = localUrl;
        userPhotoLayer.style.display = 'block';
        placeholder.style.display = 'none';
        applyBtn.disabled = false;
      } catch (e) {
        console.error("Failed to create preview", e);
      }
    }
  }

  async applyPhotoSwap() {
    const input = document.getElementById('new-photo-input');
    const applyBtn = document.getElementById('apply-photo-btn');
    const gKey = this.currentPhotoGroupKey;
    
    if (!input.files || !input.files[0] || !gKey) return;
    
    applyBtn.disabled = true;
    applyBtn.innerText = "Saving...";
    
    try {
      const file = input.files[0];
      const base64Data = await window.resizeImage(file);
      await this.updateRemoteHistoryItem(gKey, { image: base64Data });
      await this.fetchUserGallery();
      this.closePhotoModalBtn();
    } catch (e) {
      console.error("Photo swap failed", e);
      this.showCustomAlert("Failed to update photo. Please try again.");
    } finally {
      applyBtn.innerText = "Apply & Close";
      applyBtn.disabled = false;
    }
  }

  syncPhotoVariant() {
    const radio = document.querySelector('input[name="photo-orientation"]:checked');
    if (!radio) return;
    
    const selectedVariantId = radio.value;
    const matchVar = window.productVariants.find(v => String(v.id) === String(selectedVariantId));
    if (matchVar) {
      const mainProductForm = document.querySelector('form[action$="/cart/add"]');
      if (mainProductForm) {
        const mainVariantInput = mainProductForm.querySelector('input[name="id"]');
        if (mainVariantInput) {
          mainVariantInput.value = matchVar.id;
        }
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchVar.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        console.warn("Could not update variant URL param", e);
      }

      const customization = this.allCustomizations[this.selectedCustomizationIndex];
      if (customization) {
        customization.variantId = matchVar.id;
        if (this.updateRemoteHistoryItem) {
          let gKey = customization.key;
          const lastDashIndex = gKey.lastIndexOf('-');
          if (lastDashIndex !== -1) {
            gKey = gKey.substring(0, lastDashIndex);
          }
          this.updateRemoteHistoryItem(gKey, { variantId: matchVar.id });
        }
      }
      
      if (window.updateLivePrice) window.updateLivePrice();
    }
  }

  updateColorVariants() {
    const customization = this.allCustomizations[this.selectedCustomizationIndex];
    const targetId = customization ? (customization.variantId || window.productVariants[0].id) : window.productVariants[0].id;
    if (customization) {
      window.filterVariants([targetId]);
    } else {
      window.resetVariantVisibility();
    }
  }
}
